import { createProvider } from '@nvision/services/data-provider';
import { queryOptions } from '@tanstack/react-query';

import type { PostalsParams } from '../../models';
import { CACHE_KEYS } from '../../types';
import { logger } from '../../utils/logger';
import * as api from './api';
import { normalizePostals } from './normalize';

export const fetchPostals = createProvider(api.fetchPostals)
  .andThen((res) => normalizePostals(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Fetch postals search results list aborted');
    } else {
      logger.error('Fetch postals search results list was failed:', error);
    }
    throw error;
  });

export const postalsOptions = (params: PostalsParams) =>
  queryOptions({
    enabled: Boolean(params.country && (params.city || params.portPostal || params.state)),
    queryFn: ({ signal }) => fetchPostals(params, { signal }),
    queryKey: CACHE_KEYS.postals(params),
  });
